import styled from 'styled-components/macro';
import * as colors from '../../common/colorConstants';
import { lowHeightScreens, smallScreens } from '../../common/fontElements';
import { panelHeaderHeight } from '../../common/layout';

export const Tab = styled.div`
  font-size: 12px;
  color: ${colors.tabsTextColor};
  background-color: ${(props) =>
    props.isSelected && !props.disabled ? colors.tabActiveBackground : colors.baseBackground};
  height: 44px;
  ${panelHeaderHeight};

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 10px;
  }

  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  && {
    border-bottom: ${(props) => {
      if (!props.isSelected) {
        return `2px solid ${colors.baseBackground}`;
      } else if (props.disabled) {
        return `2px solid ${colors.baseBackground}`;
      }

      return `2px solid ${colors.simplrBlue}`;
    }};
  }

  text-align: center;
  white-space: nowrap;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  transition: 0.3s;
  grid-template-columns: 1fr 1fr;
  min-width: 90px;
  padding: 0 14px;
`;
Tab.displayName = 'Tab';

export const Label = styled.span`
  font-family: 'Lato-Bold', sans-serif;
  color: ${(props) => (props.disabled ? colors.lightGray12 : colors.gray)};
  font-size: 10px;
  transition: 0.3s;

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 8px;
  }
`;

export const countBoxHeight = 16;

export const CountBox = styled.div`
  box-sizing: border-box;
  display: inline-flex;
  background-color: #91b898;
  font-size: 9px;
  color: #fff;
  border-radius: 3px;
  text-align: center;
  justify-content: center;
  align-items: center;
  width: 18px;
  margin-bottom: 2px;
  height: ${countBoxHeight}px;
`;

export const Alert = styled.div`
  background-color: ${(props) => (props.disabled ? '#d9b2b3' : '#ce3b40')};
  color: white;
  font-size: 7px;
  width: 10px;
  height: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  position: relative;
  bottom: 9px;
  right: 5px;
`;
